import requestor from "shared/service/requestor";

export default class TestInstanceApi {
  try = {
    all: ({ courseId, lessonId }, testId = null, clientId = null) =>
      requestor.get("/course/test_instance_try_all", {
        course_id: courseId,
        lesson_id: lessonId,
        test_id: testId,
        client_id: clientId,
      }),
    one: ({ courseId, lessonId }, id) =>
      requestor.get("/course/test_instance_try_one", { course_id: courseId, lesson_id: lessonId, id: id }),
    save: ({ courseId, lessonId }, form) =>
      requestor.patch("/course/test_instance_try_save", {
        course_id: courseId,
        lesson_id: lessonId,
        LessonTestInstanceTry: form,
      }),
    clientAnswerSetScore: ({ courseId, lessonId }, clientAnswerId, score) =>
      requestor.patch("/course/test_instance_try_client_answer_set_score", {
        course_id: courseId,
        lesson_id: lessonId,
        LessonTestQuestionInstanceClientAnswer: {
          id: clientAnswerId,
          score: score,
        },
      }),
    comment: {
      all: ({ courseId, lessonId }, tryId) =>
        requestor.get("/course/test_instance_try_comment_all", {
          course_id: courseId,
          lesson_id: lessonId,
          model_id: tryId,
        }),
    },
  };
}
